import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { Location as LocationModel } from 'models/locations';
import SellerModel from 'models/seller';

import Gallery from 'components/location/image/gallery';
import SellerLogo from 'components/parking-passes/info-section/seller-logo';
import PrintLink from 'components/common/links/print-link';

export default function LocationInfo({ location, seller }) {
  const directionButtonClasses = cx({
    'btn-primary': true,
    'btn-block': true,
    'text-center': true,
    'with-vertical-margin': true,
    'iconified': true,
    'iconified-space-right': true,
    'iconified-directions-white': true,
    'hidden-print': true,
  });

  return (
    <div className="location-info row">
      <div className="col-md-4 col-xs-10 col-md-offset-2 col-xs-offset-1">
        <div className="address h6-sg text-weight-medium text-color-dark-slate without-vertical-margin line-height-extra">{location.address.toUpperCase()}</div>
        <div className="venue-name h6-sg text-weight-book text-color-slate line-height-extra">{location.name}</div>
        <div className="venue-name h6-sg text-weight-book text-color-slate line-height-extra">
          <FormattedMessage
            id="common.operated-by"
            defaultMessage="Operated by {seller}"
            values={{ seller: seller.name }}
          />
        </div>
        <SellerLogo seller={seller} location={location} />
        <a
          href={location.googleMapURL()}
          target="_blank"
          rel="noopener noreferrer"
          className={directionButtonClasses}
        >
          <FormattedMessage id="parking-pass.get-directions" defaultMessage="GET DIRECTIONS" />
        </a>
        <PrintLink label="PRINT PASS" labelId="parking-pass.print" classNames="text-color-green text-weight-medium hidden-lte-sm" />
      </div>
      <div className="col-md-3 col-xs-10 col-xs-offset-1 col-md-offset-1">
        <Gallery location={location} maxHeight={190} width={250} seller={seller} />
      </div>
    </div>
  );
}

LocationInfo.propTypes = {
  location: PropTypes.instanceOf(LocationModel).isRequired,
  seller: PropTypes.instanceOf(SellerModel).isRequired,
};
